import React, { useState } from "react";
import { Button, Input, ToggleButton } from "@public/ui-toolkit";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import 'react-responsive-modal/styles.css';
import ReactModal from "@public/ui-toolkit/src/ReactModal";

const UplaodPerformanceMetrixModal = ({
  uploadTearSheet,
  id,
  loading,
  onSuccess,
}) => {
  const dispatch = useDispatch();
  const [toggle, setToggle] = useState(true);
  const [open, setOpen] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => {
    setOpen(false);
  }


  var curr = new Date();
  curr.setDate(curr.getDate());
  var date = curr.toISOString().substring(0, 10);
  const formik = useFormik({
    initialValues: {
      monthlyReturn: "",
      //alphaRatio: "",
      month: "",
      file: "",
      annualizedReturns: "",
      annualizedVolatility: "",
      ytd: "",
    },
    validationSchema: Yup.object({
      monthlyReturn: Yup.string().required("Monthly return is required!"),
      month: Yup.string().required("Month is required!"),
      file: Yup.string(),
      ...(!toggle && {
        annualizedVolatility: Yup.string().required("Annualized Volatility is required!"),
        annualizedReturns: Yup.string().required("Annualized Returns is required!"),
        ytd: Yup.string().required("Ytd is required!"),
      }),
    }),
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append(`Document`, values.file);
      formData.append(`FundId`, id);
      formData.append(`IsManualData`, toggle);
      formData.append(`MonthlyReturn`, values.monthlyReturn);
      formData.append(`AnnualizedReturn`, values.annualizedReturns ? values.annualizedReturns : 0);
      formData.append(`AnnualVolatility`, values.annualizedVolatility ? values.annualizedVolatility : 0);
      formData.append(`Ytd`, values.ytd ? values.ytd : 0);
      formData.append(`Month`, values.month);
      dispatch(uploadTearSheet(formData, onSuccess , onCloseModal));
    },
  });

  return (
    <>
      <Button
        btnName="Upload Tear Sheet"
        btnType="!primary"
        iconClass="fa fa-download mr-2"
        onClick={onOpenModal}
        type="button"
      />
      <div>
        <ReactModal open={open} onClose={onCloseModal} center title={"Upload Tear Sheet"} >
          <form onSubmit={formik.handleSubmit}>
            <div className="modal-body">
              <div class="row p-2">
                <div class="col-lg-6 p-2">
                  <Input
                    id="myDate"
                    name="date"
                    forr="date"
                    type="date"
                    placeholder="Month"
                    label="Month"
                    onChange={(e) =>
                      formik.setFieldValue("month", e.target.value)
                    }
                  />
                  {formik.touched.month && formik.errors.month ? (
                    <div className="form-error-message">
                      {formik.errors.month}
                    </div>
                  ) : null}
                </div>
                <div class="col-lg-6 p-2">
                  <Input
                    id="monthly-return"
                    forr="monthly-return"
                    type="number"
                    placeholder="Monthly Return"
                    label="Monthly Return"
                    step="any"
                    {...formik.getFieldProps("monthlyReturn")}
                  />
                  {formik.touched.monthlyReturn &&
                    formik.errors.monthlyReturn ? (
                    <div className="form-error-message">
                      {formik.errors.monthlyReturn}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="row p-2">
                <Input
                  type="file"
                  id="file"
                  name="file"
                  onChange={(e) =>
                    formik.setFieldValue("file", e.target.files[0])
                  }
                  accept=".pdf"
                />
                {formik.touched.file && formik.errors.file ? (
                  <div className="form-error-message">{formik.errors.file}</div>
                ) : null}
              </div>
              <hr />
              <div
                className="d-flex flex-row justify-content-between align-items-center"
                style={{ margin: "10px" }}
              >
                <h6>Use Default Formula</h6>
                <ToggleButton
                  isChecked={toggle}
                  onChange={() => setToggle(!toggle)}
                />
              </div>
              {!toggle && (
                <>
                  <div className="d-flex flex-row justify-content-between align-items-center">
                    <div class="p-2" style={{ width: "50%" }}>
                      <Input
                        id="annualizedReturns"
                        forr="annualizedReturns"
                        type="number"
                        placeholder="Annualized Returns"
                        label="Annualized Returns"
                        step="any"
                        {...formik.getFieldProps("annualizedReturns")}
                      />
                      {formik.touched.annualizedReturns &&
                        formik.errors.annualizedReturns ? (
                        <div className="form-error-message">
                          {formik.errors.annualizedReturns}
                        </div>
                      ) : null}
                    </div>
                    <div class="p-2" style={{ width: "50%" }}>
                      <Input
                        id="annualizedVolatility"
                        forr="annualizedVolatility"
                        type="number"
                        placeholder="Annualized Volatility"
                        label="Annualized Volatility"
                        step="any"
                        {...formik.getFieldProps("annualizedVolatility")}
                      />
                      {formik.touched.annualizedVolatility &&
                        formik.errors.annualizedVolatility ? (
                        <div className="form-error-message">
                          {formik.errors.annualizedVolatility}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div class="p-2">
                    <Input
                      id="ytd"
                      forr="ytd"
                      type="number"
                      placeholder="YTD"
                      label="YTD"
                      step="any"
                      {...formik.getFieldProps("ytd")}
                    />
                    {formik.touched.ytd &&
                      formik.errors.ytd ? (
                      <div className="form-error-message">
                        {formik.errors.ytd}
                      </div>
                    ) : null}
                  </div>
                </>
              )}
            </div>

            <div className="d-block text-center">
              <Button
                btnName="Upload"
                btnType="primary"
                loading={loading}
                type="submit"
              />
            </div>
          </form>
        </ReactModal>
      </div>
    </>
  );
};

export default UplaodPerformanceMetrixModal;
